import { Link } from 'react-router-dom'
import { ROUTES } from '@shared/config/routes'
import './LegalFooter.css'

/** Футер с юридическими ссылками (GDPR/EU): Terms, Privacy, Refund. */
const LegalFooter = () => (
  <footer className="legal-footer">
    <nav className="legal-footer__links">
      <Link to={ROUTES.TERMS} className="legal-footer__link">Terms</Link>
      <span className="legal-footer__sep" aria-hidden="true">·</span>
      <Link to={ROUTES.PRIVACY} className="legal-footer__link">Privacy</Link>
      <span className="legal-footer__sep" aria-hidden="true">·</span>
      <Link to={ROUTES.REFUND} className="legal-footer__link">Refund policy</Link>
    </nav>
    <p className="legal-footer__copy">
      © {new Date().getFullYear()} Pauline Cake
    </p>
  </footer>
)

export default LegalFooter
